import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/alert_icon.svg'


const _withScopeId = n => (_pushScopeId("data-v-b5b073b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "component predict" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "22",
  viewBox: "0 0 20 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    cx: "10",
    cy: "11",
    r: "10",
    fill: "#FF5560"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.2188 5.6875L10.9531 13.4844H8.5L8.21875 5.6875H11.2188ZM8.20312 15.6562C8.19531 14.8281 8.88281 14.1562 9.71875 14.1562C10.5156 14.1562 11.2266 14.8281 11.2344 15.6562C11.2266 16.5 10.5156 17.1719 9.71875 17.1719C8.88281 17.1719 8.19531 16.5 8.20312 15.6562Z",
    fill: "#24263A"
  })
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "chart-box" }
const _hoisted_6 = {
  key: 0,
  class: "chart",
  id: "tdm_predict_chart"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("h3", null, "예측 결과 정확도 낮음")
], -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "res-box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "TDM Value", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "｜", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Class", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "｜", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["info-box", {'match': _ctx.predictRes.matching}])
      }, [
        _hoisted_2,
        (_ctx.predictRes.matching)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_3, "예측된 TDM 값과 분류가 일치합니다."))
          : (_openBlock(), _createElementBlock("h3", _hoisted_4, "예측된 TDM 값과 분류가 일치하지 않습니다. 주의하여 사용하십시오."))
      ], 2),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.chartOptions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["alert-box", {show: _ctx.showPredictAlert}])
      }, _hoisted_8, 2),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", null, [
          _hoisted_10,
          _hoisted_11,
          _createElementVNode("h3", {
            class: _normalizeClass({alert: _ctx.showPredictAlert})
          }, _toDisplayString((_ctx.predictRes.last_reg).toFixed(2)), 3)
        ]),
        _createElementVNode("div", null, [
          _hoisted_12,
          _hoisted_13,
          _createElementVNode("h3", {
            class: _normalizeClass({alert: _ctx.showPredictAlert})
          }, _toDisplayString(_ctx.predictRes.range_classes), 3)
        ])
      ])
    ]),
    _createElementVNode("button", {
      class: "button__blue init_btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.initRes()))
    }, "초기화")
  ], 64))
}